import ExerciseGenerator from "./ExerciseGenerator";
import {getRandomIntegerWithRange} from "../Random";
import Exercise from "../Exercise";
import ResultItem from "../ResultItem";
import NumberSystems from "../NumberSystems";

export default class GradualDivisionExerciseGenerator extends ExerciseGenerator {
    generate = (task) => {
        /*
        Example
        Task: 50
        50 / 2 = 25 R 0 (R = Remainder)
        25 / 2 = 12 R 1 (If remainder > 0: R = 1 else R = 0)
        12 / 2 =  6 R 0
        6 / 2  =  3 R 0
        3 / 2  =  1 R 1
        1 = 2  =  0 R 1
         */

        if(!task) {
            //generate random int
            task = getRandomIntegerWithRange(1, 256);
        }
        //Prepare variable for division
        let resultValue = task;
        //Result[] will contain all results
        const result = [];
        //Iterate until 0
        let counter = 0;
        while(counter < 100 && resultValue > 0){
            counter++;
            //We need to use integers only for this, math floor will return an integer
            const value = Math.floor(resultValue / 2);
            //Check the modulus of the remainder. If its larger than 0, store a 1 else store a 0
            const remainder = resultValue%2 > 0 ? 1 : 0;
            result.push(new ResultItem(String(value), NumberSystems.DECIMAL, true, true));
            result.push(new ResultItem(String(remainder), NumberSystems.BINARY, true, true));
            //Update resultValue so we can exit the loop eventually
            resultValue = value;
        }
        return new Exercise([task], [String(task)], result);
    }

}